export const formatStartDate = (date: string) => {
  if (!date) {
    return;
  }

  const currentDate = new Date(date);

  const formattedDate = new Intl.DateTimeFormat('de', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  }).format(currentDate);

  return formattedDate.replace(',', '.');
};

export const formatDate = (date?: Date | string) => {
  if (!date) {
    return;
  }

  const currentDate = new Date(date);
  // Extract date components
  const day = String(currentDate.getDate()).padStart(2, '0');
  const month = String(currentDate.getMonth() + 1).padStart(2, '0');
  const year = String(currentDate.getFullYear()).slice(-2);
  const hours = String(currentDate.getHours()).padStart(2, '0');
  const minutes = String(currentDate.getMinutes()).padStart(2, '0');

  // Format the date and time
  return `${day}.${month}.${year} - ${hours}:${minutes}`;
};

export const formatDateFile = (date: Date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  return `${year}-${month}-${day}-${hours}${minutes}${seconds}`;
};
